import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { keyBy, pick } from 'lodash';
import { t } from '../../../infra/i18n';
import { ItemsContainer as Items } from './items.container';
import { useActiveBrandTax } from '../network';
import { useApiQuery } from '../../../infra/api';
import { useRouteParams } from '../../../infra/routing';
import { endpoints } from '../../../shared/services/network';
import { useSession } from '../../../infra/session';
import Loading from '../../../../app/main/customers/customersList/loading';
import { useApplyTax } from './use-apply-tax';
export var ServicesContainer = function () {
    var params = useRouteParams();
    var session = useSession().data;
    var brand = ((session === null || session === void 0 ? void 0 : session.view) || { viewer: null }).viewer;
    var servicesQuery = useApiQuery({
        endpoint: endpoints.servicesQuery,
        payload: {
            ownerId: brand === null || brand === void 0 ? void 0 : brand.id,
            ownerType: 'brand',
            allAtOnce: true,
        },
        options: {
            enabled: !!brand,
        },
    });
    var serviceCategoriesQuery = useApiQuery({
        endpoint: endpoints.serviceCategoriesQuery,
        payload: {
            ownerId: brand === null || brand === void 0 ? void 0 : brand.id,
            ownerType: 'brand',
            allAtOnce: true,
        },
        options: {
            enabled: !!brand,
        },
    });
    // refetch on mount because we need to send the data from the tax's `assignments` field when applying tax to services
    // since that field might be changes in the neighboring tabs of the form, making sure we have the latest data here
    var taxQuery = useActiveBrandTax(params.id, { refetchOnMount: true });
    var taxRef = useRef(null);
    taxRef.current = taxQuery.data;
    var saveAssignment = useApplyTax('service', brand === null || brand === void 0 ? void 0 : brand.id, taxRef);
    var isLoading = servicesQuery.isLoading || taxQuery.isLoading;
    if (isLoading) {
        return _jsx(Loading, {});
    }
    var enabledServiceItems = taxQuery.data.taxable.filter(function (item) { return item.type === 'service'; });
    var enabledServiceItemsById = keyBy(enabledServiceItems, 'id');
    var items = servicesQuery.data.map(function (service) {
        return {
            id: service.id,
            name: service.name,
            initiallyEnabled: !!enabledServiceItemsById[service.id],
            categories: service.categories.map(function (category) { return pick(category, ['id', 'name']); }),
        };
    });
    var categories = serviceCategoriesQuery.data.rows.map(function (category) { return pick(category, ['id', 'name']); });
    return (_jsx(Items, { items: items, categories: categories, saveAssignment: saveAssignment, title: t('settings:taxes.apply_rates_to_services') }));
};
